export const locale = {
  lang: 'en',
  data: {
    DOWNLOAD: 'Download',
    REMOVE: 'Remove',
    NOT_SUPPORT: 'This file-type preview is not supported by the system. Download it to view.',
    NOT_SUPPORT_WHEN_TYPING: 'This file-type preview is not supported by the system.',
    AT: 'at',
  },
};
